import React, { useEffect, useState } from 'react';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiButton, EuiLoadingContent } from '@elastic/eui';
import API from '../../api/axios/API';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { getLiveOrders } from '../../api/liveOrders/getLiveOrderNewAPI';
import { getLiveOrderDetailsAPI } from '../../api/liveOrders/getLiveOrderDetailsAPI';

export const ScoutRiderTab = (props) => {
    const { order } = props;
    const [priceEstimate, setPriceEstimate] = useState({});
    const dispatch = useDispatch();

    const tdStyle = {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    };

    const scoutCostEstimate = async () => {
        let scoutResponse;

        try {
            scoutResponse = await API.post(`/restaurants/:restaurantId/scout-rider/get-order-estimation-time`, {
                orderId: props.orderId,
            });
        } catch (error) {
            scoutResponse = error;
        }

        if (scoutResponse.success) {
            setPriceEstimate(scoutResponse);
        } else {
            alert('Error in fetching price estimate');
        }
    };

    useEffect(() => {
        scoutCostEstimate();
    }, []);

    const assignScoutRider = async () => {
        let scoutResponse = '';
        try {
            scoutResponse = await API.post(`/restaurants/:restaurantId/scout-rider/assign-orders `, {
                orderId: props.orderId,
            });
        } catch (error) {
            scoutResponse = error;
        }

        if (scoutResponse.success) {
            props.setRiderModalOpen();
            // props.stateUpdateData((prevState) => !prevState)
            dispatch(getLiveOrders());
            dispatch(getLiveOrderDetailsAPI());
        } else {
            alert(scoutResponse.message);
        }
    };

    return (
        <EuiFlexGroup direction='column'>
            <EuiFlexItem>
                {!isEmpty(priceEstimate) ? (
                    <EuiFlexItem>
                        <b>Scout Estimates</b>
                        <table style={{ marginTop: '10px' }}>
                            <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                <td style={{ borderRight: '1px solid #D3DAE6' }}>Estimated Distance</td>
                                {/* <td>:</td> */}
                                <td style={tdStyle}>
                                    {priceEstimate.data.distance
                                        ? `${parseFloat(priceEstimate.data.distance).toFixed(2)} Km`
                                        : ''}
                                </td>
                            </tr>
                            <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                <td style={{ borderRight: '1px solid #D3DAE6' }}>Estimated price</td>
                                {/* <td>:</td> */}
                                <td style={tdStyle}>
                                    {priceEstimate.data.estimated_price
                                        ? `${parseFloat(priceEstimate.data.estimated_price).toFixed(2)}`
                                        : ''}
                                </td>
                            </tr>
                            <tr style={{ borderBottom: '1px solid #D3DAE6' }}>
                                <td style={{ borderRight: '1px solid #D3DAE6' }}>Estimated Drop off time</td>
                                {/* <td>:</td> */}
                                <td style={tdStyle}>
                                    {priceEstimate.data.estimation_drop_off
                                        ? `${priceEstimate.data.estimation_drop_off} Mins`
                                        : ''}
                                </td>
                            </tr>
                        </table>
                    </EuiFlexItem>
                ) : (
                    <EuiLoadingContent lines={5} />
                )}
            </EuiFlexItem>
            <EuiFlexItem style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <EuiButton fullWidth={true} fill onClick={assignScoutRider}>
                    Assign Scout Rider
                </EuiButton>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
};
